import styled from 'styled-components';
import { ScreenWidth } from 'web-common/src/shared/styles';

export const DishFirstExploreWidthLimit = styled.div`
  width: 100%;

  @media (min-width: ${ScreenWidth.MEDIUM}) {
    width: 800px;
  }
  @media (min-width: ${ScreenWidth.LARGE}) {
    width: 1066px;
  }

  margin-right: auto;
  margin-left: auto;
`;
